/** A save operation that cannot be done; the message is one the screens translate (GDD §6.3). */
export class SaveOperationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SaveOperationError';
  }
}
